export { isLoading, doneLoading } from '../config/actions';

// --- Action Types ---

// All actions related to generating a new blank classification
export const GENERATE_CLASSIFICATION = 'classifications/GENERATE_CLASSIFICATION';
export interface GenerateClassificationAction {
  readonly type: typeof GENERATE_CLASSIFICATION;
}

export const LOOKUP_CLASSIFICATIONS = 'classifications/LOOKUP_CLASSIFICATIONS';
export interface LookupClassificationsAction {
  readonly meta: ActionMetaData;
  readonly type: typeof LOOKUP_CLASSIFICATIONS;
}

export const LOOKUP_CLASSIFICATIONS_COMPLETE = 'classifications/LOOKUP_CLASSIFICATIONS_COMPLETE';
export interface LookupClassificationsCompleteAction {
  readonly type: typeof LOOKUP_CLASSIFICATIONS_COMPLETE;
  readonly payload: ReadonlyArray<Classification>;
}

export const LOOKUP_CLASSIFICATION = 'classifications/LOOKUP_CLASSIFICATION';
export interface LookupClassificationAction {
  readonly type: typeof LOOKUP_CLASSIFICATION;
  readonly payload: number | string;
}

export const LOOKUP_CLASSIFICATION_COMPLETE = 'classifications/LOOKUP_CLASSIFICATION_COMPLETE';
export interface LookupClassificationCompletePayload {
  readonly data: Classification;
  readonly etag: string;
}
export interface LookupClassificationCompleteAction {
  readonly type: typeof LOOKUP_CLASSIFICATION_COMPLETE;
  readonly payload: LookupClassificationCompletePayload;
}

export const CREATE_CLASSIFICATION = 'classifications/CREATE_CLASSIFICATION';
export interface CreateClassificationAction {
  readonly type: typeof CREATE_CLASSIFICATION;
  readonly payload: Classification;
}

export const EDIT_CLASSIFICATION = 'classifications/EDIT_CLASSIFICATION';
export interface EditClassificationAction {
  readonly type: typeof EDIT_CLASSIFICATION;
  readonly payload: Classification;
}

export const EDIT_DEFAULT_CLASSIFICATION = 'classifications/EDIT_DEFAULT_CLASSIFICATION';
export interface EditDefaultClassificationAction {
  readonly type: typeof EDIT_DEFAULT_CLASSIFICATION;
  readonly payload: number;
}

export const EDIT_DEFAULT_CLASSIFICATION_COMPLETE = 'classifications/EDIT_DEFAULT_CLASSIFICATION_COMPLETE';
export interface EditDefaultClassificationCompleteAction {
  readonly type: typeof EDIT_DEFAULT_CLASSIFICATION_COMPLETE;
  readonly payload: Classification;
}

export const DELETE_CLASSIFICATION = 'classifications/DELETE_CLASSIFICATION';
export interface DeleteClassificationAction {
  readonly type: typeof DELETE_CLASSIFICATION;
  readonly payload: Classification;
}

export const DELETE_CLASSIFICATION_COMPLETE = 'classifications/DELETE_CLASSIFICATION_COMPLETE';
export interface DeleteClassificationCompleteAction {
  readonly type: typeof DELETE_CLASSIFICATION_COMPLETE;
}

export const CLEAR_CLASSIFICATIONS = 'classifications/CLEAR_CLASSIFICATIONS';
export interface ClearClassificationAction {
  readonly type: typeof CLEAR_CLASSIFICATIONS;
}

export type ClassificationAction =
  | GenerateClassificationAction
  | LookupClassificationsAction
  | LookupClassificationsCompleteAction
  | LookupClassificationAction
  | LookupClassificationCompleteAction
  | CreateClassificationAction
  | EditClassificationAction
  | EditDefaultClassificationAction
  | EditDefaultClassificationCompleteAction
  | DeleteClassificationAction
  | DeleteClassificationCompleteAction
  | ClearClassificationAction;

// --- Actions ---

export const createClassification = (classification: Classification): CreateClassificationAction => ({
  payload: classification,
  type: CREATE_CLASSIFICATION,
});

export const generateClassification = (): GenerateClassificationAction => ({
  type: GENERATE_CLASSIFICATION,
});

export const lookupClassifications = (): LookupClassificationsAction => ({
  meta: {
    allowedRoles: [],
  },
  type: LOOKUP_CLASSIFICATIONS,
});

export const lookupClassificationsComplete = (
  catalog: ReadonlyArray<Classification>,
): LookupClassificationsCompleteAction => ({
  payload: catalog,
  type: LOOKUP_CLASSIFICATIONS_COMPLETE,
});

// All actions related to doing a lookup of a single classification
export const lookupClassification = (id: number | string): LookupClassificationAction => ({
  payload: id,
  type: LOOKUP_CLASSIFICATION,
});

export const lookupClassificationComplete = ({
  data,
  etag,
}: LookupClassificationCompletePayload): LookupClassificationCompleteAction => ({
  payload: {
    data,
    etag,
  },
  type: LOOKUP_CLASSIFICATION_COMPLETE,
});

// All actions related to editing an existing classification
export const editClassification = (classification: Classification): EditClassificationAction => ({
  payload: classification,
  type: EDIT_CLASSIFICATION,
});

// All actions related to selecting a new default classification

export const editDefaultClassification = (classification: Classification): EditDefaultClassificationAction => ({
  payload: classification.id!,
  type: EDIT_DEFAULT_CLASSIFICATION,
});

export const editDefaultClassificationComplete = (
  classification: Classification,
): EditDefaultClassificationCompleteAction => ({
  payload: classification,
  type: EDIT_DEFAULT_CLASSIFICATION_COMPLETE,
});

// All actions related to deleting an existing classification

export const deleteClassification = (classification: Classification) => ({
  payload: classification,
  type: DELETE_CLASSIFICATION,
});

export const deleteClassificationComplete = (): DeleteClassificationCompleteAction => ({
  type: DELETE_CLASSIFICATION_COMPLETE,
});

// All actions related to clearing the Classifications state
export const clearClassifications = (): ClearClassificationAction => ({
  type: CLEAR_CLASSIFICATIONS,
});
